<template>
  <div>
    <div v-if="$device.isMobile">
      <nuxt />
    </div>
    <div v-else class="body-container">
      <Header />
      <div class="content">
        <nuxt />
      </div>
      <Footer />
    </div>
    <portal-target name="destination" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {}
  },
  computed: mapState(['user'])
}
</script>

<style>
html {
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  height: 100%;
}

.body-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: #111827;
}

.content {
  flex: 1;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
</style>
